<template>
    <div class="compensation-steps">
        <ul class="compensation-steps__list">
            <li class="compensation-steps__item"
                v-for="(step, idx) in steps" 
                    :key="idx">
                <CompensationStep :text-html="step.textHtml"
                    :order-number="idx + 1"
                    :hide-step-arrow="idx === steps.length - 1"
                    />
            </li>
        </ul>
    </div>
</template>

<script>
import CompensationStep from '@/components/ui/CompensationStep';
export default {
    name: 'CompensationSteps',
    components: {
        CompensationStep
    },
    data() {
        return {
            steps: [
                { textHtml: 'Сообщите в страховую компанию по телефону <a href="tel:+78007007707">8 800 700 77 07</a> или электронной почте <a href="mailto:info@zettains.ru">info@zettains.ru</a>' },
                { textHtml: 'Подготовьте необходимые документы оператор страховой компании поможет определить перечень' },
                { textHtml: 'Действуйте согласно рекомендациям страховой компании' },
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.compensation-steps {
    &__list {
        display: flex;
        justify-content: space-between;

        @media #{$screen-medium} {
            flex-direction: column;
        }
    }

    &__item {
        @include flex-width-three-in-row($gap-xl);

        @media #{$screen-big} {
            @include flex-width-three-in-row($gap-great);
        }

        @media #{$screen-medium} {
            @include resetting-vertical-indentation-of-first;
            
            width: 100%;
            margin-top: rem($gap-great);
        }
    }
}
</style>